exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:iconfont;src:url(\"//at.alicdn.com/t/font_2673219_5aqrthp55qf.woff2?t=1626234416015\") format(\"woff2\"),url(\"//at.alicdn.com/t/font_2673219_5aqrthp55qf.woff?t=1626234416015\") format(\"woff\"),url(\"//at.alicdn.com/t/font_2673219_5aqrthp55qf.ttf?t=1626234416015\") format(\"truetype\")}.iconfont{font-family:iconfont!important;font-size:16px;font-style:normal;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-youjian:before{content:\"\\E600\"}.icon-sangeren:before{content:\"\\E601\"}.iconhomeicon:before{content:\"\\E602\"}.icon-miaoshu:before{content:\"\\E644\"}.icon-f-earth-diqiu:before{content:\"\\E7D6\"}.icon-miaoshu1:before{content:\"\\E772\"}.icon-dizhi:before{content:\"\\EBBD\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/iconfont.css
// module id = 788
// module chunks = 0